// @flow
import React from 'react';
import { Button, Icons } from 'sarsaparilla';

export default function ExpandMainViewButton({ onClick, isExpanded }: { onClick: Function, isExpanded: boolean }) {
    const toggleButtonText = isExpanded ? 'Collapse Table' : 'Expand Table';
    const toggleButtonIcon = isExpanded ? <Icons.IconContract /> : <Icons.IconExpand />;
    const buttonScreenReaderText = (action) => `- ${action} the Trip Itinerary (this is for visual users only)`
    const toggleButtonScreenReaderText = isExpanded ? buttonScreenReaderText("View") : buttonScreenReaderText("Hide");
    return (
        <Button
            appearance="link"
            size="sm"
            className="toggle-button"
            title="Toggle Expand Table"
            onClick={onClick}
            iconBeforeElement={toggleButtonIcon}
            screenReaderTextAfter={toggleButtonScreenReaderText}>
            {toggleButtonText}
        </Button>
    )
}